<template>
  <div class="check-work-body">
    <div class="d-flex-left">
      <div class="tree-wrap">
        <div class="project-selector">
          <el-select
            size="mini"
            style="width: 100%"
            v-model="jurisdictionId"
            filterable
            placeholder="选择架构"
            :clearable="true"
            @clear="refreshTree"
            @change="checkedGetList"
          >
            <el-option
              v-for="item in jurisdictionList"
              :key="item.id"
              :label="item.department_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>

        <div class="el-tree-1">
          <el-tree
            ref="tree"
            :data="data"
            :props="defaultProps"
            :lazy="true"
            :load="getData"
            @node-click="handleNodeClick"
          ></el-tree>
        </div>
      </div>
    </div>
    <div class="d-flex-right">
      <el-card class="box-card">
        <template slot="header">
          <span style="font-size: 14px">操作员设置</span>
          <el-button
            style="float: right; margin-bottom: 5px"
            type="primary"
            icon="el-icon-plus"
            @click="add"
            >添加</el-button
          >
        </template>
        <el-form ref="from" :model="params" label-width="100px">
          <el-col :span="6">
            <el-form-item label="操作员姓名">
              <el-input
                v-model="params.keyword"
                placeholder="请输入操作员姓名或账号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="角色">
              <el-select
                v-model="params.role_id"
                filterable
                placeholder="选择角色"
                :clearable="true"
              >
                <el-option
                  v-for="item in RoleLists"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="操作员状态">
              <el-select
                v-model="params.status"
                filterable
                placeholder="选择状态"
                :clearable="true"
              >
                <el-option
                  v-for="item in adminStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="在职状态">
              <el-select
                v-model="params.is_dimission"
                filterable
                placeholder="选择状态"
                :clearable="true"
              >
                <el-option
                  v-for="item in dimissionStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="5">
            <el-form-item label="部门状态">
              <el-input v-model="params.departmentStatus"></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="24">
            <el-form-item>
              <el-button
                type="primary"
                @click="search"
                icon="el-icon-search"
                >搜索</el-button
              >
              <el-button type="text" @click="clean">重置</el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-card>
      <el-table class="box-table" :data="adminInfos" border style="width: 100%">
        <el-table-column label="操作员姓名" width="100">
          <template slot-scope="data">
            <el-link
              :underline="false"
              type="primary"
              @click="view(data.row)"
              >{{ data.row.name }}</el-link
            >
          </template>
        </el-table-column>
        <el-table-column prop="username" label="操作员账号" width="100" />
        <el-table-column prop="xsc_user_id" label="员工编号" width="80" />
        <el-table-column prop="ancestor_name" label="部门" width="700" />
        <el-table-column label="状态" width="50">
          <template slot-scope="data">
            {{ data.row.status == 1 ? "在用" : "禁用" }}
          </template>
        </el-table-column>
        <el-table-column label="角色" width="180">
          <template slot-scope="data">
            <el-collapse accordion>
              <el-collapse-item title="查看角色">
                <el-tag
                  v-for="(item, key) in data.row.roleNames"
                  :key="key"
                  style="margin-right: 3px; margin-bottom: 3px"
                >
                  {{ item }}
                </el-tag>
              </el-collapse-item>
            </el-collapse>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="240">
          <template slot-scope="data">
            <el-button type="text" @click="view(data.row)"> 查看 </el-button>
            <el-button type="text" @click="edit(data.row)"> 编辑 </el-button>
            <el-button type="text" @click="propertyRight(data.row)">
              房产权限
            </el-button>
            <el-button type="text" @click="departmentRight(data.row)">
              部门权限
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="float: right; margin-top: 8px"
        background
        :page-size.sync="pageSize"
        layout="sizes, total, prev, pager, next"
        :total="totalCount"
        :current-page.sync="page"
      />
    </div>
    <operator-detail
      ref="OperatorDetail"
      :dialogVisible.sync="viewer.dialogVisible"
      :id="viewer.id"
      :name="viewer.name"
      :mode="viewer.mode"
      @close="closeDetail"
    />
    <operator-property-select
      ref="OperatorPropertySelect"
      :dialogVisible.sync="propertyViewer.dialogVisible"
      :id="propertyViewer.id"
      :name="propertyViewer.name"
      :mode="propertyViewer.mode"
      @close="closePropertyRight"
    />
    <operator-department-select
      ref="OperatorDepartmentSelect"
      :dialogVisible.sync="departmentViewer.dialogVisible"
      :id="departmentViewer.id"
      :name="departmentViewer.name"
      :mode="departmentViewer.mode"
      @close="closeDepartment"
    />
  </div>
</template>
<script>
import Http from "@/components/Admin/Flow/common/Http";
import OperatorDetail from "@/components/Admin/Config/Operator/OperatorDetail";
import OperatorPropertySelect from "@/components/Admin/Config/Operator/OperatorPropertySelect";
import OperatorDepartmentSelect from "@/components/Admin/Config/Operator/OperatorDepartmentSelect";
export default {
  name: "OperatorList",
  components: { OperatorDetail, OperatorPropertySelect, OperatorDepartmentSelect },
  data() {
    return {
      page: 1,
      pageSize: 10,
      totalCount: 100,
      viewer: {
        mode: "view",
        dialogVisible: false,
        id: null,
        name: "",
      },
      data: [],
      jurisdictionList: [],
      jurisdictionId: "",
      params: {
        keyword: "",
        department_id: "",
        role_id: "",
        status: "",
        is_dimission: "",
      },
      adminInfos: [],
      defaultProps: {
        children: "",
        label: "department_name",
      },
      RoleLists: [],
      adminStatus: [
        {
          label: "在用",
          value: 1,
        },
        {
          label: "禁用",
          value: 0,
        },
      ],
      dimissionStatus: [
        {
          label: "在职",
          value: 0,
        },
        {
          label: "离职",
          value: 1,
        },
      ],
      propertyViewer: {
        id: null,
        dialogVisible: false,
        name: "选择房产",
        mode: "view",
      },
      departmentViewer: {
        id: null,
        dialogVisible: false,
        name: "选择房产",
        mode: "view",
      },
    };
  },
  mounted() {
    this.myGetList();
    this.search();
    this.getRoleList();
  },
  watch: {
    page(n) {
      this.search();
    },
    pageSize(n) {
      this.search();
    },
  },
  methods: {
    search() {
      this.params.page = this.page;
      this.params.page_size = this.pageSize;
      Http.post("hr/user/getUserListB", this.params, (res) => {
        this.adminInfos = res.data;
        this.totalCount = res.total;
      });
    },
    getRoleList() {
      Http.post("flow/role/searchList", {}, (res) => {
        this.RoleLists = res.RoleInfos;
      });
    },
    //部门全部list
    myGetList(params, url) {
      Http.get("hrm/department/list", params, (res) => {
        if (res.code === 0) {
          this.data = res.data;
          this.jurisdictionList = res.data;
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    clean() {
      this.params = {
        keyword: "",
        department_id: "",
        role_id: "",
        status: "",
      };
      this.search();
    },
    view(row) {
      this.viewer = {
        dialogVisible: true,
        id: row.id,
        name: row.username,
        mode: "view",
      };
    },
    edit(row) {
      this.viewer = {
        dialogVisible: true,
        id: row.id,
        name: row.username,
        mode: "edit",
      };
    },
    add() {
      this.viewer = {
        dialogVisible: true,
        id: null,
        name: "添加操作员",
        mode: "add",
      };
    },
    closeDetail() {
      this.viewer.dialogVisible = false;
    },
    //刷新右边树
    refreshTree() {
      this.myGetList();
      this.jurisdictionId = [];
    },
    //点击树形节点+搜索  = 输出表格
    handleNodeClick(data) {
      var department_id = "";
      if (data) {
        department_id = data.id;
      }
      this.params.department_id = department_id;
      this.search();
    },
    //单选部门list
    checkedGetList(params, url) {
      Http.get(
        "hrm/department/list",
        {
          parent_id: params,
        },
        (res) => {
          if (res.code === 0) {
            this.data = res.data;
          } else {
            this.$message.error({
              message: res.msg,
              type: "error",
            });
          }
        }
      );
    },
    //节点下面的数据
    getData(node, resolve) {
      // console.log(node.level, node.data)
      var region_id = node.data.id; //选中节点id
      // console.log(region_id);
      setTimeout(() => {
        //节点不能为空
        if (region_id == "" || region_id == undefined) {
          return false;
        }
        //加载
        node.data.region_id = region_id;

        node.data &&
          Http.get(
            "hrm/department/list",
            { parent_id: node.data.id },
            (backdata) => {
              // 异步执行成功后
              // _this.defaultcheckedkeys =  _this.arr;
              // console.log(backdata.data.data);
              return resolve(backdata.data);
            }
          );
      }, 300);
    },
    propertyRight(row) {
      this.propertyViewer = {
        dialogVisible: true,
        id: row.id,
        name: row.name,
        mode: "view",
      };
    },
    closePropertyRight() {
      this.propertyViewer.dialogVisible = false;
    },
    departmentRight(row) {
      this.departmentViewer = {
        dialogVisible: true,
        id: row.id,
        name: row.name,
        mode: "view",
      };
    },
    closeDepartment() {
      this.departmentViewer.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.el-button--primary[type=button] {
  color: #FFF;
}
.box-card {
  width: 100%;
  height: 200px;
  margin-left: 8px;
}
.box-table {
  overflow-y: scroll;
  height: calc(100vh - 350px);
  margin-top: 8px;
  margin-left: 8px;
}

.d-flex-left {
  float: left;
  width: 250px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}
.d-flex-right {
  float: right;
  width: calc(100% - 260px);
}

.tree-wrap {
  width: 250px;
}
.project-selector {
  margin-bottom: 10px;
}

.el-tree-1 {
  overflow-y: scroll;
  height: calc(100vh - 120px);
  width: 100%;
}
.check-work-body {
  padding: 15px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Config/Operator/OperatorList.vue